import React from "react";
import classNames from "classnames";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "../../../assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function KidsAdviceSection(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.kidsAdvice, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h5 className={classes.description}>
            Dando cumplimiento a lo previsto en la <strong>Ley 679 de 2001</strong> y la <strong>Ley 1336 de 2009</strong>,
            VIVAMOS EL CAMPO S.A.S con RNT 135625, en el desarrollo de su actividad,
            cumplirá lo previsto en el Código de Conducta <strong>contra la utilización y explotación laboral
            y sexual de niños, niñas y adolescentes.</strong>
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(KidsAdviceSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/KidsAdviceSection.jsx